import { createUseSuggestions } from "@decocms/blocks/sdk/useSuggestions";
import type { Suggestion } from "@decocms/apps-commerce/types";

export const { useSuggestions } = createUseSuggestions<Suggestion>();
